export const RECENT_DOCUMENTS_POLLING_INTERVAL = 1000 * 60 * 10; // 10 minutes

export enum GlobalSearchTypesEnum {
  invoices = 'invoices',
  estimates = 'estimates',
  credit_memos = 'credit_memos',
  purchase_orders = 'purchase_orders',
  clients = 'clients',
  items = 'items',
  expenses = 'expenses',
  appointments = 'appointments',
  tracked_times = 'tracked_times',
}

export enum DocumentsSearchTypesEnum {
  invoices = 'invoices',
  estimates = 'estimates',
  credit_memos = 'credit_memos',
  purchase_orders = 'purchase_orders',
}
export interface ISearchParams {
  query?: string;
  highlights?: boolean;
  page_size?: number;
}
